import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import ConfiguratorPage from './pages/ConfiguratorPage';
import GalleryPage from './pages/GalleryPage';
import DetailPage from './pages/DetailPage';
import UploadPage from './pages/UploadPage';
import ProfilePage from './pages/ProfilePage';
import AdminLayout from './pages/admin/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import ReviewQueue from './pages/admin/ReviewQueue';
import ConfigurationManagement from './pages/admin/ConfigurationManagement';
import OfficialUpload from './pages/admin/OfficialUpload';
import POCPage from './pages/poc/POCPage';
import ModelAnalyzer from './pages/poc/ModelAnalyzer';
import SharePoster from './components/share/SharePoster';
// 配置详情页面
import ConfigDetailPage from './pages/ConfigDetailPage';
// 传奇系统页面
import LegendsPage from './pages/LegendsPage';
import LegendDetailPage from './pages/LegendDetailPage';
import HallOfFamePage from './pages/HallOfFamePage';
import RiderProfilePage from './pages/RiderProfilePage';
import LegendPosterPage from './pages/LegendPosterPage';
import styles from './App.module.css';

// Layout wrapper for main site (with Footer - only for Configurator)
function MainLayout({ children, showFooter = false }) {
    return (
        <div className={styles.app}>
            <Header />
            <main className={styles.main}>
                {children}
            </main>
            {showFooter && <Footer />}
        </div>
    );
}

function App() {
    return (
        <BrowserRouter>
            <Routes>
                {/* Admin Routes - separate layout */}
                <Route path="/admin" element={<AdminLayout />}>
                    <Route index element={<AdminDashboard />} />
                    <Route path="review" element={<ReviewQueue />} />
                    <Route path="management" element={<ConfigurationManagement />} />
                    <Route path="official" element={<OfficialUpload />} />
                </Route>

                {/* 3D Preview - 集成到主站 */}
                <Route path="/3d-preview" element={<MainLayout><POCPage /></MainLayout>} />

                {/* POC Page - 技术验证 (无 Header/Footer，保留开发用) */}
                <Route path="/poc" element={<POCPage />} />
                <Route path="/analyzer" element={<ModelAnalyzer />} />
                <Route path="/poster-preview" element={
                    <div style={{ display: 'flex', justifyContent: 'center', padding: '20px', background: '#333' }}>
                        <SharePoster />
                    </div>
                } />

                {/* Main Site Routes */}
                <Route path="/" element={<MainLayout showFooter={true}><ConfiguratorPage /></MainLayout>} />
                <Route path="/gallery" element={<MainLayout><GalleryPage /></MainLayout>} />
                <Route path="/gallery/upload" element={<MainLayout><UploadPage /></MainLayout>} />
                <Route path="/gallery/:id" element={<MainLayout><DetailPage /></MainLayout>} />
                <Route path="/config/:id" element={<MainLayout><ConfigDetailPage /></MainLayout>} />
                <Route path="/profile" element={<MainLayout><ProfilePage /></MainLayout>} />

                {/* 传奇系统路由 */}
                <Route path="/legends" element={<MainLayout><LegendsPage /></MainLayout>} />
                <Route path="/legend/:legendId" element={<MainLayout><LegendDetailPage /></MainLayout>} />
                <Route path="/legend/:legendId/poster" element={<MainLayout><LegendPosterPage /></MainLayout>} />
                <Route path="/hall-of-fame" element={<MainLayout><HallOfFamePage /></MainLayout>} />
                <Route path="/rider/:riderId" element={<MainLayout><RiderProfilePage /></MainLayout>} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
